export const URL_KIND = `/utility/initializers`;

export const types = {
   GET_KIND_LOADING: "GET_KIND_LOADING",
   GET_KIND_SUCCESS: "GET_KIND_SUCCESS",
   GET_KIND_FAILED: "GET_KIND_FAILED"
};
